export const loginEndpoint = '/User/UserLogin';
